import { render, staticRenderFns } from "./PlatformActivity.vue?vue&type=template&id=68c4995a&scoped=true&"
import script from "./PlatformActivity.vue?vue&type=script&lang=js&"
export * from "./PlatformActivity.vue?vue&type=script&lang=js&"
import style0 from "./PlatformActivity.vue?vue&type=style&index=0&id=68c4995a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c4995a",
  null
  
)

export default component.exports